import React, { useState } from 'react';
import './style.scss';

import image1 from 'assets/img/welcome/registration1.webp';
import image2 from 'assets/img/welcome/registration2.webp';

import metrics1 from 'assets/img/welcome/metrics1.webp';
import metrics2 from 'assets/img/welcome/metrics2.webp';
import metrics3 from 'assets/img/welcome/metrics3.webp';

import mt1 from 'assets/img/welcome/mt1.webp';
import mt2 from 'assets/img/welcome/mt2.webp';
import mt3 from 'assets/img/welcome/mt3.webp';
import mt4 from 'assets/img/welcome/mt4.webp';
import mt5 from 'assets/img/welcome/mt5.webp';

import { BottomNavigation } from 'scenes/PatientRegistration/Navigation';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { useAppSelector } from 'careand-redux/store';
import { shouldShowPermissionScreen } from 'scenes/HomePatient2/Permissions';
import i18n from 'services/i18n';
import { getTenantIdentity } from 'hooks/useTenantIdentity';

export const PatientWelcome = () => {
  const nav = useNavStack(Stacks.Master);
  const permissions = useAppSelector((state) => state.device.permissions);

  return (
    <div className="page tutorial-screen">
      <TutorialScreens
        slides={PATIENT_WELCOME_SLIDES}
        onFinish={() => {
          if (shouldShowPermissionScreen(permissions)) {
            nav.pushAsFirst('/permissions');
          } else {
            nav.pushAsFirst('/');
          }
        }}
      />
    </div>
  );
};

export const MetricsClinicWelcome = ({ onFinish }) => (
  <TutorialScreens slides={getMetricsClinicWelcomeSlides()} onFinish={onFinish} />
);

export const MetricsAppleWelcome = ({ onFinish }) => (
  <TutorialScreens slides={METRICS_APPLE_WELCOME_SLIDES} onFinish={onFinish} />
);

export const MenstruationTrackerWelcome = ({ onFinish }) => (
  <div className="page tutorial-screen">
    <TutorialScreens slides={MENSTRUATION_TRACKER_WELCOME_SLIDES} onFinish={onFinish} />
  </div>
);

const TutorialScreens = ({ slides, onFinish }) => {
  const [step, setStep] = useState(0);
  const slide = slides[step];

  function onClickedNext() {
    let newStep = step + 1;
    if (newStep >= slides.length) {
      onFinish();
    } else {
      setStep(newStep);
    }
  }

  return (
    <>
      <Slide
        title={slide.title}
        text={slide.text}
        image={slide.image}
        element={slide.element}
        imageStyle={slide.imageStyle}
      />
      <BottomNavigation
        id="step-next"
        steps={slides.length}
        currentStep={step}
        onClick={onClickedNext}
      />
    </>
  );
};

const Slide = (props) => (
  <div className="slide">
    <div className="row slide-image center-text animated fadeInRight" key={props.image}>
      <img
        style={props.imageStyle}
        alt={props.title}
        src={props.image}
        height="250"
        className="mx-auto"
      />
    </div>

    <div className="row slide-text animated fadeInRight" key={props.title}>
      <span className="small-title">{props.title}</span>
      <span>{props.text}</span>
      {props.element}
    </div>
  </div>
);

const PATIENT_WELCOME_SLIDES = [
  {
    image: image1,
    title: 'Book appointments or chat with us anytime',
    text: 'You can book an appointment by tapping the “Schedule Consultation” button on the home screen',
    element: (
      <span className="box">
        Have a question or need assistance?
        <br />
        Tap the <b>"Chat With a {i18n.staffTitle}"</b> button anytime!
      </span>
    ),
  },
  {
    image: image2,
    title: 'Manage Accounts of Family Members',
    text: 'Manage accounts for your family members by linking them to your account. Book appointments for them, receive notifications, and easily access their health records.',
  },
];

const getMetricsClinicWelcomeSlides = () => [
  {
    image: metrics1,
    title: 'Clinic & Lab',
    text: `Store and visualize your health data securely with the ${
      getTenantIdentity().name
    } app. Access metrics from clinic visits and lab results in one place.`,
  },
];

const METRICS_APPLE_WELCOME_SLIDES = [
  {
    image: metrics2,
    title: 'Apple Health',
    text: 'Share your Apple Health data to help your practitioner improve your care. You choose what to include and we ensure secure encryption and privacy.',
  },
  {
    image: metrics3,
    title: 'Integration with Apple Health',
    text: 'To grant us permission to access your Apple Health data, you need to authorize our app. If you decline access, you can enable it later through the permission settings in iOS.',
  },
];

const MENSTRUATION_TRACKER_WELCOME_SLIDES = [
  {
    image: mt1,
    imageStyle: { minHeight: '300px' },
    title: 'Cycle Tracking',
    text: 'A medical-grade menstruation tracker. Cycle Tracking uses the latest knowledge and techniques to provide you with accurate menstrual cycle predictions',
  },
  {
    image: mt2,
    imageStyle: { minHeight: '250px' },
    title: 'Reminders',
    text: 'Be prepared. You can setup reminders so that we will send you push notifications to remind you to log your symptoms, when you are the most fertile and when your next period is going to appear.',
  },
  {
    image: mt3,
    imageStyle: { minHeight: '300px' },
    title: 'Predictions',
    text: 'Be prepared by knowing in advance when your period is coming. We use heuristics to make predictions about your period so that know when you are going to ovulate, when you are the most fertile and when your next period is going to appear.',
  },
  {
    image: mt4,
    imageStyle: { minHeight: '300px' },
    title: 'Track Your Symptoms',
    text: 'Cycle Tracking allows you to track medically relevant symptoms which become part of your health records. So that you and your practitioner can be on the same page.',
  },
  {
    image: mt5,
    imageStyle: { minHeight: '300px' },
    title: 'Cycle Health Analysis',
    text: 'Cycle Tracking uses latest knowledge in female health to analyze your cycle. We will let you know if we find something out of ordinary in your cycle.',
  },
];
